export const formatGeolocation = (props: { city?: string; country?: string; region?: string } | undefined) => {
  const location = [props?.city, props?.region, props?.country].filter(f => f !== undefined)

  if (location.length > 0) return location.join(', ')

  return null
}
